import { render } from "./AdminCommercants.vue?vue&type=template&id=ae94d4c2&scoped=true"
import script from "./AdminCommercants.vue?vue&type=script&lang=js"
export * from "./AdminCommercants.vue?vue&type=script&lang=js"

import "./AdminCommercants.vue?vue&type=style&index=0&id=ae94d4c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae94d4c2"]])

export default __exports__